import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { Navigate, useNavigate, useSearchParams } from 'react-router';
import { useNotification } from '@/context/notification';
import { useResetPassword } from '@/data/auth';
import { PasswordForm } from '@/packages/auth/components/password-form';
import {
  type PasswordFormData,
  passwordFormSchema,
} from '@/packages/auth/components/password-form/schema';

export const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { toast } = useNotification();
  const { mutate: resetPassword, isPending } = useResetPassword();

  const token = searchParams.get('token');

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<PasswordFormData>({
    resolver: zodResolver(passwordFormSchema),
    defaultValues: {
      password: '',
      confirmPassword: '',
    },
  });

  const submitting = isSubmitting || isPending;

  const onSubmit = async (data: PasswordFormData) => {
    if (!token) return;

    resetPassword(
      { senha: data.password, token },
      {
        onSuccess: () => {
          toast({
            content: 'Senha redefinida com sucesso!',
            type: 'success',
          });
          navigate('/');
        },
        onError: () => {
          toast({
            content:
              'Erro ao redefinir senha. Tente novamente ou entre em contato com o atendimento.',
            type: 'error',
          });
        },
      }
    );
  };

  if (!token) return <Navigate to="/login" replace />;

  return (
    <PasswordForm
      control={control}
      onSubmit={handleSubmit(onSubmit)}
      submitting={submitting}
    />
  );
};
